export const ACTION_PREFIX_LISTS = 'LISTS/'
export const ACTION_PREFIX_BANK_ACCOUNT_LIST = 'banking/bankAccountList'
